import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { Notification, ROLES } from '../types';
import { getNotifications } from '../utils/httpRequest';

export interface NotificationState {
  notifications: Notification;
  loading: boolean;
  error?: string;
}

const initialState: NotificationState = {
  notifications: {
    issueList: [],
    causeList: [],
    routineList: [],
  },
  loading: false,
  error: '',
};

export const fetchNotifications = createAsyncThunk(
  'notifications/fetchNotifications',
  async () => {
    const notifications = await getNotifications();

    return notifications;
  }
);

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotifications: (state, action: PayloadAction<Notification>) => {
      state.notifications = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        const { issueList, causeList, routineList } = action.payload;
        state.notifications = {
          issueList: issueList || [],
          causeList: causeList || [],
          routineList: routineList || [],
        };
        state.loading = false;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.error = 'Error';
        state.loading = false;
      });
  },
});

export const { setNotifications } = notificationSlice.actions;

export default notificationSlice.reducer;

export const selectNotifications = (state: RootState) =>
  state.notification.notifications;
export const selectNotificationsNumber = (state: RootState) => {
  const { issueList, causeList, routineList } =
    state.notification.notifications;

  return (
    Number(issueList?.length) +
    Number(causeList?.length) +
    Number(routineList?.length)
  );
};
export const selectNotificationIssues = (state: RootState) =>
  state.notification.notifications.issueList || [];
export const selectNotificationCauses = (state: RootState) =>
  state.notification.notifications.causeList || [];
export const selectNotificationRoutines = (state: RootState) =>
  state.notification.notifications.routineList || [];
